import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    // {
    //   path: '/introduction',
    //   name: 'introduction',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/Introduction.vue'),
    // },
    {
      path: '/guide',
      name: 'guide',
      component: Layout,
      redirect: '/guide/introduction',
      children: [
        { path: 'introduction', name: 'introduction', component: () => import('./views/Introduction.vue') },
        { path: 'install', name: 'install', component: () => import('./views/Install.vue') },
        { path: 'get-started', name: 'get-started', component: () => import('./views/GetStarted.vue') },
      ],
    },
    {
      path: '/components',
      name: 'components',
      component: Layout,
      children: [
        { path: 'icon', name: 'icon', component: () => import('./views/Icon.vue') },
        { path: 'button', name: 'button', component: () => import('./views/Button.vue') },
        { path: 'grid', name: 'grid', component: () => import('./views/Grid.vue') },
        { path: 'message', name: 'message', component: () => import('./views/Message.vue') },
        { path: 'collapse', name: 'collapse', component: () => import('./views/Collapse.vue') },
        { path: 'pager', name: 'pager', component: () => import('./views/Pager.vue') },
        { path: 'tab', name: 'tab', component: () => import('./views/Tab.vue') },
        { path: 'sticky', name: 'sticky', component: () => import('./views/Sticky.vue') },
        { path: 'popover', name: 'popover', component: () => import('./views/Popover.vue') },
        { path: 'cascader', name: 'cascader', component: () => import('./views/Cascader.vue') },
        { path: 'menu', name: 'menu', component: () => import('./views/Menu.vue') },
        { path: 'date-picker', name: 'date-picker', component: () => import('./views/DatePicker.vue') },
      ],
    },
  ],
})
